import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";
import CircularProgressBar from '../../../Common/ProgressBar/CircularProgressBar';

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
};

const displayTime = (timeStr) => {
  if (!timeStr) return "";
  const t = timeStr.slice(0,5);
  try {
    const [h, m] = t.split(":").map(Number);
    const dt = new Date();
    dt.setHours(h, m, 0, 0);
    return dt.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
  } catch {
    return t;
  }
};

const buildFileUrl = (filename) => {
  if (!filename) return "";
  const clean = filename.toString().replace(/^\/+/, "").replace(/^Tender\//i, "");
  return `${REACT_APP_API_URL.replace(/\/$/, "")}/Tender/${clean}`;
};
const TendersAdminDashboard = () => {
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState({
    TenderId: 0,
    TenderNo: "",
    Title: "",
    Description: "",
    ClosingDate: "",
    ClosingTime: "",
    OpeningDate: "",
    OpeningTime: "",
    IsActive: true,
    RFP: "",
    Notice: "",
    PreBid: "",
    Supporting: "",
    Corrigendum: "",
    Query: "",
    MeetingLink: "",
    MeetingDate: "",
    MeetingTime: "",
  });
  const fileInputs = ["RFP", "Notice", "PreBid", "Supporting", "Corrigendum", "Query"];
  const [newFiles, setNewFiles] = useState({
    RFP: null, Notice: null, PreBid: null, Supporting: null, Corrigendum: null, Query: null
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => { fetchTenders(); }, []);

  const fetchTenders = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${REACT_APP_API_URL.replace(/\/$/, "")}/api/tender/get`);
      setTenders(res.data || []);
    } catch (err) {
      console.error("Error fetching tenders:", err);
      alert("Failed to fetch tenders");
    } finally {
      setLoading(false);
    }
  };

  const openAdd = () => {
    setForm({
      TenderId: 0, TenderNo: "", Title: "", Description: "",
      ClosingDate: "", ClosingTime: "", OpeningDate: "", OpeningTime: "",
      IsActive: true, RFP: "", Notice: "", PreBid: "", Supporting: "", Corrigendum: "", Query: "",
      MeetingLink: "", MeetingDate: "", MeetingTime: ""
    });
    setNewFiles({ RFP: null, Notice: null, PreBid: null, Supporting: null, Corrigendum: null, Query: null });
    setIsEditing(false);
    setShowForm(true);
  };

  const openEdit = (t) => {
    const safe = (val) => val === null || val === undefined ? "" : val;
    setForm({
      TenderId: t.TenderId,
      TenderNo: safe(t.TenderNo),
      Title: safe(t.Title),
      Description: safe(t.Description),
      ClosingDate: t.ClosingDate ? t.ClosingDate.slice(0,10) : "",
      ClosingTime: safe(t.ClosingTime).slice(0,5),
      OpeningDate: t.OpeningDate ? t.OpeningDate.slice(0,10) : "",
      OpeningTime: safe(t.OpeningTime).slice(0,5),
      IsActive: Boolean(t.IsActive),
      RFP: safe(t.RFP), Notice: safe(t.Notice), PreBid: safe(t.PreBid),
      Supporting: safe(t.Supporting), Corrigendum: safe(t.Corrigendum), Query: safe(t.Query),
      MeetingLink: safe(t.MeetingLink),
      MeetingDate: t.MeetingDate ? t.MeetingDate.slice(0,10) : "",
      MeetingTime: safe(t.MeetingTime).slice(0,5)
    });
    setNewFiles({ RFP: null, Notice: null, PreBid: null, Supporting: null, Corrigendum: null, Query: null });
    setIsEditing(true);
    setShowForm(true);
  };

  const handleFileChange = (e, key) => {
    const files = e.target.files;
    setNewFiles(prev => ({ ...prev, [key]: files && files.length ? files : null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("TenderNo", form.TenderNo);
      formData.append("Title", form.Title);
      formData.append("Description", form.Description || "");
      formData.append("ClosingDate", form.ClosingDate || "");
      formData.append("ClosingTime", form.ClosingTime || "");
      formData.append("OpeningDate", form.OpeningDate || "");
      formData.append("OpeningTime", form.OpeningTime || "");
      formData.append("MeetingLink", form.MeetingLink || "");
      formData.append("MeetingDate", form.MeetingDate || "");
      formData.append("MeetingTime", form.MeetingTime || "");
      formData.append("IsActive", form.IsActive ? "1" : "0");
      fileInputs.forEach((key) => {
        const files = newFiles[key];
        if (files && files instanceof FileList && files.length > 0) {
          Array.from(files).forEach(file => formData.append(key, file));
        }
      });

      setIsUploading(true);
      setUploadProgress(0);

      if (!isEditing) {
        await axios.post(`${REACT_APP_API_URL.replace(/\/$/, "")}/api/tender/new-tender`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);
          }
        });
        alert("Tender added successfully");
      } else {
        await axios.put(`${REACT_APP_API_URL.replace(/\/$/, "")}/api/tender/edit-tender/${form.TenderId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);
          }
        });
        alert("Tender updated successfully");
      }

      setIsUploading(false);
      setShowForm(false);
      fetchTenders();
    } catch (err) {
      console.error("Error saving tender:", err);
      alert("Error saving tender");
      setIsUploading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this tender?")) return;
    try {
      await axios.delete(`${REACT_APP_API_URL.replace(/\/$/, "")}/api/tender/remove-tender/${id}`);
      fetchTenders();
      alert("Tender deleted successfully");
    } catch (err) {
      console.error(err);
      alert("Delete failed");
    }
  };
  const getMeetingStatus = (date, time) => {
  if (!date || !time) return "NO_MEETING";
  const [day, monthStr, year] = date.split(" ");
  const monthMap = {
    Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
    Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
  };
  const month = monthMap[monthStr];
  if (month === undefined) return "INVALID";
  let hours, minutes;
  if (time.toLowerCase().includes("am") || time.toLowerCase().includes("pm")) {
    const [t, meridian] = time.split(" ");
    let [h, m] = t.split(":").map(Number);
    if (meridian.toLowerCase() === "pm" && h !== 12) h += 12;
    if (meridian.toLowerCase() === "am" && h === 12) h = 0;
    hours = h;
    minutes = m;
  } else {
    [hours, minutes] = time.split(":").map(Number);
  }
  const meetingDateTime = new Date(
    Number(year),
    month,
    Number(day),
    hours,
    minutes,
    0
  );
  const now = new Date();
  if (now >= meetingDateTime) return "ENDED";
  const diffMinutes = (meetingDateTime - now) / 60000;
  if (diffMinutes > 60) return "COMING_SOON";
  return "ACTIVE";
};


  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Tenders Dashboard</h3>
        <button className="btn btn-primary" onClick={openAdd}>Add Tender</button>
      </div>

      {loading ? <p>Loading...</p> : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Tender No</th>
                <th>Title</th>
                <th>Description</th>
                <th>Closing</th>
                <th>Opening</th>
                <th>Documents</th>
                <th>Meeting</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tenders.length === 0 ? (
                <tr><td colSpan="8" className="text-center">No tenders available</td></tr>
              ) : tenders.map((t) => (
                <tr key={t.TenderId}>
                  <td>{t.TenderNo}</td>
                  <td>{t.Title}</td>
                  <td>{t.Description || "-"}</td>
                  <td>{t.ClosingDate ? formatDate(t.ClosingDate) : "-"} {t.ClosingTime && `(${displayTime(t.ClosingTime)})`}</td>
                  <td>{t.OpeningDate ? formatDate(t.OpeningDate) : "-"} {t.OpeningTime && `(${displayTime(t.OpeningTime)})`}</td>
                  <td>
                    {["RFP","Notice","PreBid","Supporting","Corrigendum","Query"].map((key) => (
                      <div key={key}>
                        {t[key] && t[key].split("||").filter(p => p.trim() !== "").map((p, i) => (
                          <a key={`${key}-${i}`} href={buildFileUrl(p)} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary me-1 mb-1">
                            {key} {i+1}
                          </a>
                        ))}
                      </div>
                    ))}
                  </td>
                  <td>
                      {t.MeetingDate ? (
                        <>
                          <div><strong>Date:</strong> {formatDate(t.MeetingDate)}</div>
                          <div><strong>Time:</strong> {displayTime(t.MeetingTime)}</div>

                          {(() => {
                            const status = getMeetingStatus(t.MeetingDate, t.MeetingTime);

                            if (status === "ENDED" || status === "NO_MEETING") return "-";

                            return (
                              t.MeetingLink && (
                                <button
                                  className="btn btn-sm btn-success mt-1"
                                  onClick={() => window.open(t.MeetingLink, "_blank")}
                                >
                                  Join Meeting
                                </button>
                              )
                            );
                          })()}
                        </>
                      ) : "-"}
                    </td>
                  <td>
                    <button className="btn btn-sm btn-info me-2" onClick={() => openEdit(t)}>Edit</button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(t.TenderId)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content" style={{ position: 'relative' }}>
              <div className="modal-header">
                <h5 className="modal-title">{isEditing ? "Edit Tender" : "Add Tender"}</h5>
                <button type="button" className="btn-close" onClick={() => setShowForm(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4 mb-2">
                      <label className="form-label">Tender No</label>
                      <input required className="form-control" value={form.TenderNo} onChange={e => setForm({...form, TenderNo: e.target.value})} />
                    </div>
                    <div className="col-md-8 mb-2">
                      <label className="form-label">Title</label>
                      <input required className="form-control" value={form.Title} onChange={e => setForm({...form, Title: e.target.value})} />
                    </div>
                    <div className="col-md-12 mb-2">
                      <label className="form-label">Description</label>
                      <textarea className="form-control" rows="2" value={form.Description} onChange={e => setForm({...form, Description: e.target.value})}></textarea>
                    </div>

                    <div className="col-md-3 mb-2">
                      <label>Closing Date</label>
                      <input type="date" className="form-control" value={form.ClosingDate} onChange={e => setForm({...form, ClosingDate: e.target.value})} />
                    </div>
                    <div className="col-md-3 mb-2">
                      <label>Closing Time</label>
                      <input type="time" className="form-control" value={form.ClosingTime} onChange={e => setForm({...form, ClosingTime: e.target.value})} />
                    </div>
                    <div className="col-md-3 mb-2">
                      <label>Opening Date</label>
                      <input type="date" className="form-control" value={form.OpeningDate} onChange={e => setForm({...form, OpeningDate: e.target.value})} />
                    </div>
                    <div className="col-md-3 mb-2">
                      <label>Opening Time</label>
                      <input type="time" className="form-control" value={form.OpeningTime} onChange={e => setForm({...form, OpeningTime: e.target.value})} />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label>Meeting Date</label>
                      <input type="date" className="form-control" value={form.MeetingDate} onChange={e => setForm({...form, MeetingDate: e.target.value})} />
                      <label>Meeting Time</label>
                      <input type="time" className="form-control" value={form.MeetingTime} onChange={e => setForm({...form, MeetingTime: e.target.value})} />
                      <label className="form-label mt-2">Google Meet Link</label>
                      <input type="url" className="form-control" value={form.MeetingLink} onChange={e => setForm({...form, MeetingLink: e.target.value})} placeholder="https://meet.google.com/xyz-abc-def" />
                    </div>

                    {fileInputs.map((key) => (
                      <div className="col-md-4 mb-2" key={key}>
                        <label>{key} (PDF)</label>
                        <input type="file" accept="application/pdf" multiple className="form-control" onChange={(e) => handleFileChange(e, key)} />
                        {form[key] && typeof form[key] === "string" && form[key].length > 0 && form[key].split("||").map((p, i) => {
                          const filename = p.replace(/^\/+/, "").replace(/^Tender\//i, "");
                          return (
                            <small className="text-success d-block mt-1" key={i}>
                              Existing: <a href={buildFileUrl(filename)} target="_blank" rel="noreferrer">{filename}</a>
                            </small>
                          );
                        })}
                        {newFiles[key] && Array.from(newFiles[key]).map((f, i) => <small className="d-block mt-1" key={i}>{f.name}</small>)}
                      </div>
                    ))}

                    <div className="col-md-3 mb-2">
                      <label>Active</label>
                      <select className="form-control" value={form.IsActive ? "1" : "0"} onChange={(e) => setForm({...form, IsActive: e.target.value === "1"})}>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                  </div>

                  <div className="mt-3 text-end">
                    <button type="submit" className="btn btn-success me-2" disabled={isUploading}>
                      {isUploading ? "Uploading..." : (isEditing ? "Update" : "Save")}
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
                  </div>
                </form>

                {isUploading && (
                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.9)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10 }}>
                    <CircularProgressBar progress={uploadProgress} />
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TendersAdminDashboard;
